<script>
  import { mapGetters } from 'vuex';
  import Sms from '@/assets/sms.svg';
  import Icon from '@/components/Icon';
  import Modal from '@/components/Modal';
  import AppSwitch from '@/components/Switch';
  import FormInput from '@/components/Form/Input';
  import WalletWind from '@/assets/wallet-wind.svg';
  import FormCheckbox from '@/components/Form/Checkbox';
  import WalletArrowRed from '@/assets/wallet-arrow-red.svg';

  export default {
    components: {
      Sms,
      Icon,
      Modal,
      AppSwitch,
      FormInput,
      WalletWind,
      FormCheckbox,
      WalletArrowRed,
    },

    data: () => ({
      step: 0,

      form: {
        fee: 1,
        notes: '',
        all: false,
        address: '',
        quantity: '',
      },

      auth: {
        code: '',
        password: '',
      },
    }),

    computed: {
      ...mapGetters('coins', [
        'coin',
      ]),

      title () {
        if (this.step === 2) {
          return `Confirmar envio de ${this.coin.initial}`;
        }

        return `Enviar ${this.coin.title}`;
      },

      quantity () {
        return `Quantidade: (${this.coin.initial})`;
      },

      button () {
        return this.step === 0 ? 'Continuar' : 'Concluído';
      },

      items () {
        return this.fees.map(([ label ]) => label);
      },

      fees () {
        return [
          [
            'Lenta',
            'BTC 0,00004456',
          ],
          [
            'Média',
            'BTC 0,00004456',
          ],
          [
            'Rápida',
            'BTC 0,00004456',
          ],
        ];
      },
    },

    methods: {
      close () {
        this.$router.push('/carteira');
      },

      next () {
        if (this.step == 3) {
          return this.close();
        }

        this.step += 1;
      },
    },
  };
</script>

<template>
  <Modal
    :title="title"
    @close="close"
    class="wallet-send"
    >

    <template v-if="step === 0 || step === 3">
      <Icon
        :icon="coin.title"
        class="wallet-send__icon"
        />

      <span class="wallet-send__arrow">
        <WalletArrowRed
          />
      </span>

      <p class="wallet-send__text wallet-send__text--limited" v-if="step === 0">
        Somente envie {{ coin.title }} <br> {{ coin.initial }} para esse endereço
      </p>

      <template v-else-if="step === 3">
        <p class="wallet-send__text wallet-send__text--limited">
          {{ coin.title }} enviado com sucesso!
        </p>

        <ul class="wallet-send__list wallet-send__list--simple">
          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Para</span> HDX73F8F23R73HFF89
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Total</span> 0.00023039209 BTC R$7.20
          </li>
        </ul>
      </template>

      <button
        v-text="button"
        class="modal__action"
        @click.prevent="next"
        >
      </button>
    </template>

    <template v-else-if="step === 1">
      <div class="wallet-send__header">
        <Icon
          :icon="coin.title"
          class="wallet-send__header-icon"
          />

        <p class="wallet-send__header-title">
          {{ coin.initial }} CARTEIRA
        </p>

        <div class="wallet-send__header-infos">
          <p class="wallet-send__header-total">0,000343556</p>
          <p class="wallet-send__header-formated">R$45,23</p>
        </div>
      </div>

      <form
        @submit.prevent="next"
        class="wallet-send__form"
        >

        <FormInput
          required
          type="text"
          v-model="form.address"
          placeholder="Endereço da carteira"
          />

        <FormInput
          required
          type="text"
          :placeholder="quantity"
          v-model="form.quantity"
          />

        <FormCheckbox
          v-model="form.all"
          class="wallet-send__checkbox"
          >
          Usar todo o saldo
        </FormCheckbox>

        <AppSwitch
          :options="items"
          v-model="form.fee"
          #default="{ index }"
          class="wallet-send__switch"
          >
          <span
            v-text="fees[index][1]"
            >
          </span>
        </AppSwitch>

        <ul class="wallet-send__list">
          <li class="wallet-send__item">
            Taxa <span class="wallet-send__item--highlight">R$ 34,90</span>
          </li>

          <li class="wallet-send__item">
            Total Líquido <span class="wallet-send__item--highlight">R$ 34,90</span>
          </li>
        </ul>

        <FormInput
          type="text"
          v-model="form.notes"
          placeholder="Observações"
          />

        <button
          v-text="button"
          class="modal__action modal__action--full"
          >
        </button>
      </form>
    </template>

    <template v-else-if="step === 2">
      <div class="wallet-send__row">
        <ul class="wallet-send__list wallet-send__list--grid wallet-send__left">
          <li class="wallet-send__item wallet-send__item--normal">
            Detalhes da Transação
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Para:</span> HDX73F8F23R73HFF89
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Montante:</span> R$0.00
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Taxa CoinBrax:</span> R$0.00
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Taxa de Mineração:</span> 0.00023039 BTC R$2.16
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Total:</span>

            <span>
              0.00023039209 BTC <WalletWind class="wallet-send__item-icon" /> R$7.20
            </span>
          </li>

          <li class="wallet-send__item">
            <span class="wallet-send__item--highlight">Nota:</span> notecoinbrax1923
          </li>
        </ul>

        <div class="wallet-send__right">
          <p class="wallet-send__right-text">Verificação em duas etapas:</p>
          <p class="wallet-send__right-subtext">Um código SMS foi enviado para o seu celular.</p>

          <FormInput
            type="text"
            placeholder="Confirmar senha"
            v-model="auth.password"
            />

          <div class="wallet-send__form-icon">
            <span class="wallet-send__sms">
              <Sms />
            </span>

            <FormInput
              type="text"
              v-model="auth.code"
              placeholder="0 0 0 0 0 0 0"
              >
            </FormInput>
          </div>

          <button class="wallet-send__resend">
            <span class="wallet-send__resend--highlight">Não recebeu o SMS?</span>
            Envie novamente
          </button>
        </div>
      </div>

      <div class="wallet-send__footer">
        <button
          @click.prevent="close"
          class="modal__action modal__action--cancel"
          >
          Cancelar
        </button>

        <button
          class="modal__action"
          @click.prevent="next"
          >
          Confirmar
        </button>
      </div>
    </template>
  </Modal>
</template>

<style lang="scss">
  .wallet-send {
    .modal__wrapper {
      display: flex;
      min-width: 660px;
      align-items: center;
      flex-direction: column;
    }

    &__arrow {
      width: 32px;
      height: 32px;
      display: flex;
      margin-top: -24px;
      margin-left: 52px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      background-color: #14162f;

      svg {
        width: 14px;
      }
    }

    &__text {
      color: #b2b8c5;
      line-height: 1.5;
      text-align: center;
      margin: 16px 0 64px;

      &--limited {
        max-width: 214px;
      }
    }

    &__icon {
      height: 70px;
    }

    &__header {
      width: 100%;
      display: flex;
      padding: 24px;
      color: #FFF;
      border-radius: 4px;
      margin-bottom: 32px;
      align-items: center;
      box-shadow: 0 2px 5px 0 rgba(#000, .05);

      &-icon {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }

      &-title {
        font-size: 20px;
        letter-spacing: .4px;
      }

      &-infos {
        text-align: right;
        margin-left: auto;
      }

      &-total {
        line-height: 1;
        font-size: 20px;
        margin-bottom: 12px;
        letter-spacing: .4px;
      }

      &-formated {
        line-height: 1.25;
        letter-spacing: .32px;
      }
    }

    &__form {
      width: 100%;
      display: flex;
      padding: 0 24px;
      flex-direction: column;

      &-icon {
        display: flex;
        margin-bottom: 24px;
        align-items: flex-end;

        .form-input {
          margin: 0;
        }
      }
    }

    &__sms {
      height: 48px;
      display: flex;
      padding: 0 14px;
      border-radius: 6px;
      margin-right: 24px;
      align-items: center;
      background-color: #3e388b;
    }

    &__checkbox {
      margin-left: auto;
    }

    &__switch {
      .switch__button {
        height: 60px;
      }

      span {
        display: block;
        margin-top: 8px;
        font-size: 13px;
        line-height: 1.23;
        letter-spacing: .26px;
      }
    }

    &__list {
      min-width: 280px;
    }

    &__item {
      display: flex;
      font-size: 14px;
      padding: 16px 0;
      color: #b2b8c5;
      line-height: 1.14;
      align-items: center;
      letter-spacing: .28px;
      justify-content: space-between;

      &-icon {
        margin-right: 8px;
        margin-left: 20px;
      }

      &:not(:last-child) {
        border-bottom: 1px solid rgba(#939cac, .15);
      }

      &--normal {
        font-size: 16px;

        &:not(:first-child) {
          border-top: 1px solid rgba(#939cac, .15);
        }
      }

      &--highlight {
        color: #FFF;
      }
    }

    &__row {
      width: 100%;
      display: flex;
    }

    &__left {
      width: 420px;
      margin-right: 40px;
    }

    &__right {
      width: 260px;

      &-text {
        color: #b2b8c5;
        margin-bottom: 8px;
        letter-spacing: .32px;
      }

      &-subtext {
        color: #FFF;
        font-size: 14px;
        line-height: 1.43;
        margin-bottom: 32px;
      }
    }

    &__resend {
      padding: 0;
      width: 100%;
      display: flex;
      font-size: 13px;
      color: #b2b8c5;
      align-items: center;
      letter-spacing: .26px;
      justify-content: space-between;

      &--highlight {
        color: #FFF;
        font-size: 14px;
        line-height: 1.14;
      }
    }

    &__footer {
      align-self: flex-end;

      :not(:last-child) {
        margin-right: 32px;
      }
    }

    &__list--grid,
    &__list--simple {
      margin-bottom: 42px;
    }

    &__list--grid &__item {
      padding: 16px;
      border: 1px solid rgba(#939cac, .15);

      &:first-child {
        border-radius: 8px 8px 0 0;
      }

      &:last-child {
        border-radius: 0 0 8px 8px;
      }

      &:not(:last-child) {
        border-bottom: 0;
      }
    }
  }
</style>
